var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('InputField',{attrs:{"label":"2FA Code","value":_vm.code},on:{"update:value":function($event){_vm.code=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }